export default __webpack_public_path__ + "static/media/facebook-icon.8f6512c4.svg";